import './category-teaser.scss';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class CategoryTeaser {
    constructor ($element) {
        this.$categoryTeaserSliderRoot = $element;
        this.$slides = this.$categoryTeaserSliderRoot.querySelectorAll('[data-category-teaser-slider="slide"]');
        this.slider = null;
    }

    initialize () {
        if (this.$slides.length > 1) {
            this.resizeSlider();

            if (window.innerWidth < 1024) {
                this.initSlider();
            }
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$categoryTeaserSliderRoot, {
            modules: [Pagination],
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
            speed: 1000,
            slideClass: 'category-teaser__category-teaser-item',
            wrapperClass: 'category-teaser__category-teaser-items',
            pagination: {
                el: '.category-teaser__category-teaser-pagination',
                type: 'progressbar'
            },
            on: {
                slideChangeTransitionStart: () => {
                    const $progressBar = this.$categoryTeaserSliderRoot.querySelector('.slider-pagination');
                    $progressBar.classList.add('is--active');
                },
                slideChangeTransitionEnd: () => {
                    const $progressBar = this.$categoryTeaserSliderRoot.querySelector('.slider-pagination');
                    $progressBar.classList.remove('is--active');
                }
            }
        });
    }

    resizeSlider () {
        window.resizeHandler.customFunctions.push(() => {
            const windowWidth = window.innerWidth;
            if (windowWidth < 1024) {
                if (!this.slider) {
                    this.initSlider();
                }
            } else {
                if (this.slider) {
                    this.slider.destroy();
                }
            }
        });
    }
}

export { CategoryTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $categoryTeaserSliders = $context.querySelectorAll('[data-category-teaser-slider="root"]');
        if ($categoryTeaserSliders.length > 0) {
            $categoryTeaserSliders.forEach((categoryTeaserSlider) => {
                const $categoryTeaserSlider = new CategoryTeaser(categoryTeaserSlider);
                $categoryTeaserSlider.initialize();
            });
        }
    }
});
